
import {ref, watch} from "vue";
import {useRoute} from "vue-router";
import MessageBox from "../MessageBox.vue";

export default {
  components: { MessageBox },
  props: {
    message: {
      required: true,
      type: String,
    },
    animationIsReverse: {
      required: false,
      type: Boolean,
    },
  },
  setup() {
    const route = useRoute();
    const isTransitionFinished = ref(false);

    /** Reset animations everytime I leave a step. */
    watch(
      () => route.params.step,
      () => {
        if (Number(route.params.step) === 6) {
          isTransitionFinished.value = false;
        }
      }
    );

    const fluctuate = (): void => {
      if (!isTransitionFinished.value) {
        isTransitionFinished.value = true;
      }
    };

    return {
      isTransitionFinished,
      fluctuate,
    };
  },
};
